import { Network, ConnectionType } from '@capacitor/network';
import { merge, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


const nativeDev$ = new Observable<boolean>(sub => {
  const checkConnection = (
    data: {connected: boolean, connectionType: ConnectionType}
  ): boolean => {
    const list = ['wifi', 'cellular', 'unknown'];

    return data?.connected && list.includes(data?.connectionType);
  }

  Network.getStatus().then(status => {
    sub.next(checkConnection(status));
  });

  const h = Network.addListener('networkStatusChange', status => {
    sub.next(checkConnection(status));
  });
  return () => h.remove();
});

const nativeProd$ = new Observable<boolean>(sub => {
  const checkConnection = (
    data: {connected: boolean, connectionType: ConnectionType}
  ): boolean => {
    const list = ['wifi', 'cellular'];

    return data?.connected && list.includes(data?.connectionType);
  }

  Network.getStatus().then(status => {
    sub.next(checkConnection(status));
  });

  const h = Network.addListener('networkStatusChange', status => {
    sub.next(checkConnection(status));
  });
  return () => h.remove();
});


export const isOnline$ = (env: string): Observable<boolean> =>
  merge(env === 'development' ? nativeDev$ : nativeProd$).pipe(
    debounceTime(1000),     // ← add debounce here
    distinctUntilChanged() // (optional) still suppress duplicates
  );
